import { Text, Code, Box, Group, Badge, ThemeIcon } from "@mantine/core";
import { ArrowRight } from "lucide-react";
import { ProcessStep } from "../../services/logService";

export function SlipConfigurationContent({ log }: { log: ProcessStep }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const details = (log.details as any) || {};
  const configSource = details.configSource; // "slip_type_specific" | "partner_default"
  const slipType = details.slipType;
  const matchMethod = details.matchMethod; // "exact" | "alias" | "ai" | undefined

  const methodLabels: Record<string, { label: string; color: string }> = {
    exact: { label: "完全一致", color: "green" },
    alias: { label: "エイリアス", color: "blue" },
    ai: { label: "AI名寄せ", color: "violet" },
  };
  return (
    <Box mt={4}>
      <Text
        size="xs"
        c={log.status === "error" ? "red" : "inherit"}
        style={{ whiteSpace: "pre-line" }}
      >
        {log.description}
      </Text>

      {(configSource || slipType) && (
        <Box
          mt="xs"
          p="xs"
          bg="var(--mantine-color-default)"
          style={{
            borderRadius: "6px",
            border: "1px solid var(--mantine-color-default-border)",
          }}
        >
          <Group align="center" gap="sm">
            {slipType && (
              <Box style={{ flex: 1, minWidth: 0 }}>
                <Text size="10px" c="dimmed" mb={2}>
                  伝票種別
                </Text>
                <Code
                  block
                  style={{
                    fontSize: "11px",
                    padding: "4px 8px",
                    minHeight: "28px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {slipType}
                </Code>
              </Box>
            )}

            <ThemeIcon variant="transparent" c="dimmed" mt={12}>
              <ArrowRight size={16} />
            </ThemeIcon>

            <Box style={{ flex: 1, minWidth: 0 }}>
              <Text size="10px" c="dimmed" mb={2}>
                適用設定
              </Text>
              <Box
                h={28}
                px="xs"
                bg={
                  configSource === "slip_type_specific"
                    ? "var(--mantine-color-violet-light)"
                    : "var(--mantine-color-gray-light)"
                }
                style={{
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  color:
                    configSource === "slip_type_specific"
                      ? "var(--mantine-color-violet-light-color)"
                      : "var(--mantine-color-gray-light-color)",
                }}
              >
                <Text
                  size="xs"
                  fw={700}
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {configSource === "slip_type_specific" ? "種別固有設定" : "デフォルト設定"}
                </Text>
              </Box>
            </Box>

            {matchMethod && methodLabels[matchMethod] && (
              <Badge size="xs" variant="light" color={methodLabels[matchMethod].color} mt={12}>
                {methodLabels[matchMethod].label}
              </Badge>
            )}
          </Group>
        </Box>
      )}
    </Box>
  );
}
